<template>
    <section class="cd-main-content" id="cruisepagina">
        <MenuMobile />

        <HeaderFull />

        <HeroImages />

        <SendThisCruise />

        <HeroReviews v-if="false" />

        <SendThisCruiseModal v-if="false" />

        <div class="center main cruisepagina">
            <div class="width100">
                <div id="middle-content" class="width73">
                    <div id="cruisepagina-content">
                        <div class="cruisecontent width100 marginbottom10">
                            <div class="paddingbottom20">
                                <a href="javascript:history.back()">
                                    <span
                                        class="menu-tekst bold font14 darkgrey underline "
                                    >
                                        <font-awesome-icon icon="arrow-left" />
                                        Keer terug naar de aanbiedingen
                                    </span>
                                </a>
                            </div>
                            <h1 class="midblauw nomargin">
                                <transition name="fade" appear>
                                    <span
                                        class="font16"
                                        v-if="cruise.found"
                                        v-html="
                                            cruise.titel +
                                                ' met de ' +
                                                cruise.schip_naam
                                        "
                                    ></span>
                                </transition>
                            </h1>

                            <transition name="fade" appear>
                                <h2
                                    class="font14 margintop5 midblauw"
                                    v-if="cruise.found"
                                    v-html="cruise.titel_havens"
                                ></h2>
                            </transition>
                            <CruiseTopMenu />
                            <div class="clear floatleft"></div>

                            <div class="width100" id="info_cruise">
                                <div class="clear"></div>

                                <div class="shadow width100 marginbottom15">
                                    <div class="padding20">
                                        <transition name="fade" appear>
                                            <div
                                                class="width100 floatleft"
                                                v-if="cruise.found"
                                            >
                                                <div
                                                    v-if="cruise.vaarroute_img"
                                                >
                                                    <div id="center-map">
                                                        <img
                                                            :src="
                                                                cruise.vaarroute_img
                                                            "
                                                        />
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <CruiseMap
                                                        :itinerary="
                                                            cruise.itinerary
                                                        "
                                                    />
                                                </div>

                                                <CruiseHighlights
                                                    :cruise="cruise"
                                                />
                                            </div>
                                        </transition>
                                        <div class="clear"></div>
                                        <div class="clear floatleft"></div>

                                        <div class="clear floatleft"></div>
                                    </div>
                                </div>
                            </div>
                            <h3
                                style="text-align: center;"
                                class="width100 midblauw font18 boxspacing nomargin"
                            >
                                Dagplanning
                            </h3>
                            <div class="width100">
                                <div class="clear"></div>

                                <div class="shadow width100 marginbottom15">
                                    <div class="padding20">
                                        <transition name="fade" appear>
                                            <div
                                                class="width100 floatleft"
                                                v-if="cruise.found"
                                            >
                                                <CruiseItinerary
                                                    :itinerary="
                                                        cruise.itinerary
                                                    "
                                                    :rederij_id="cruise.rederij_id"
                                                    :cruise_id="cruise.id"
                                                />
                                            </div>
                                        </transition>
                                        <div class="clear"></div>
                                        <div class="clear floatleft"></div>

                                        <div class="clear floatleft"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="clear height10"></div>

                            <h3
                                style="text-align: center;"
                                class="nomargin midblauw font18 boxspacing"
                            >
                                {{ cruise.rederij_naam }}
                            </h3>

                            <ReadMoreContainer
                                :subtitle="cruise.rederij_omschrijving_kort"
                                :aliasImage="cruise.rederij_alias + '-img'"
                                :introText="cruise.rederij_omschrijving_landing"
                                :moreText="cruise.rederij_omschrijving"
                                :uspsItems="cruise.rederij_usps"
                                :domID="'info_rederij'"
                                :uspsPreview="false"
                                :href="''"
                                :linkText="''"
                            />

                            <h3
                                style="text-align: center;"
                                class="nomargin midblauw font18 boxspacing"
                            >
                                {{ cruise.schip_naam }}
                            </h3>
                            <ReadMoreContainer
                                :subtitle="cruise.schip_omschrijving_kort"
                                :aliasImage="''"
                                :introText="''"
                                :moreText="cruise.schip_omschrijving"
                                :uspsItems="cruise.schip_usps"
                                :domID="'info_schip'"
                                :uspsPreview="true"
                                :href="
                                    '/' +
                                        cruise.rederij_alias +
                                        '/' +
                                        cruise.schip_alias
                                "
                                :linkText="'Meer informatie over dit schip'"
                            />
                            <h3
                                style="text-align: center;"
                                class="nomargin midblauw font16 boxspacing"
                            >
                                Bekijk de dekken
                            </h3>
                            <DeckPlan />

                            <h3
                                v-if="false"
                                style="text-align: center;"
                                class="nomargin midblauw font18 boxspacing"
                            >
                                Hutten op de {{ cruise.schip_naam }}
                            </h3>

                            <Hutoverzicht v-if="false" />

                            <h3
                                style="text-align: center;"
                                class="nomargin midblauw font18 boxspacing"
                            >
                                Foto's van deze cruise
                            </h3>

                            <cruiseImages
                                :imgs="cruise.imgs"
                                :video="cruise.rederij_video_id"
                            />

                            <transition-group name="fade" appear>
                                <div
                                    v-if="showCampagnes"
                                    v-for="campagne in campagnes"
                                    :key="'campagne' + campagne.id"
                                >
                                    <Campagne :campagne="campagne" />
                                </div>
                            </transition-group>

                            <offerStappen :cruise="cruise" />
                            <div class="clear marginbottom20"></div>

                            <PrijzenDisclaimer />
                        </div>
                    </div>
                </div>

                <SideBar2 v-if="cruise" />

                <div class="clear"></div>
            </div>
        </div>
        <Footer2 />
    </section>
</template>

<script>
import HeroImages from './components/HeaderImagesCruise.vue'
import HeroReviews from './components/HeroReviews'
import SendThisCruise from './components/SendThisCruise.vue'
import SendThisCruiseModal from './components/SendThisCruiseModal.vue'
import SideBar2 from './components/SideBar2.vue'
import Footer2 from './components/Footer2.vue'
import CruiseTopMenu from './components/CruiseTopMenu.vue'
import CruiseMap from './components/CruiseMap.vue'
import CruiseHighlights from './components/CruiseHighlights.vue'

import CruiseItinerary from './components/CruiseItinerary.vue'
import DeckPlan from './components/DeckPlan.vue'
import ReadMoreContainer from './components/ReadMoreContainer.vue'
import CruiseImages from './components/CruiseImages.vue'
import offerStappen from './components/offerStappen.vue'
import PrijzenDisclaimer from './components/PrijzenDisclaimer.vue'
import Campagne from './components/Campagne.vue'
import HeaderFull from './components/HeaderFull'
import MenuMobile from './components/MenuMobile.vue'
import Hutoverzicht from './components/Hutoverzicht.vue'

export default {
    name: 'cruisepagina',
    components: {
        HeroImages,
        HeroReviews,
        SendThisCruise,
        SendThisCruiseModal,
        SideBar2,
        CruiseMap,
        DeckPlan,
        CruiseHighlights,
        Footer2,
        CruiseTopMenu,
        CruiseItinerary,
        ReadMoreContainer,
        CruiseImages,
        offerStappen,
        PrijzenDisclaimer,
        Campagne,
        MenuMobile,
        HeaderFull,
        Hutoverzicht,
    },
    data: function() {
        return { cruiseTitle: 'Cruise' }
    },
    head: {
        title: function() {
            return { inner: this.cruiseTitle }
        },
        meta: [{ name: 'description', content: 'My description', id: 'desc' }],
    },
    methods: {
        pageTitle: function() {
            if (
                this.cruise.titel &&
                this.cruise.schip_naam &&
                this.cruise.titel_havens
            ) {
                let title =
                    this.cruise.titel +
                    ' met de ' +
                    this.cruise.schip_naam +
                    ' ' +
                    this.cruise.titel_havens
                return title.replace('&amp;', '&')
            }
        },
    },
    computed: {
        cruise: function() {
            return this.$store.state.cruise
        },
        highlightedRate: function() {
            return this.$store.state.highlightedRate
        },
        campagnes: function() {
            let cruiseID = this.highlightedRate.cruiseID
            let current = this.$store.state.campagnes.find(function(departure) {
                return departure.cruiseID === cruiseID
            })

            if (current === null || typeof current === 'undefined') {
                return []
            }

            return current.campagnes
        },
        showCampagnes: function() {
            return this.highlightedRate.cruiseID > 0
        },
    },
    watch: {
        cruise() {
            if (!this.cruise.found) {
                this.$router.push({ name: 'NotFound' })
            }
            this.cruiseTitle = this.pageTitle()

            this.$nextTick(function() {
                this.$emit('updateHead')
            })
        },
    },
    mounted: function() {
        const pieces = this.$route.params.id.split('-')
        const selectedCabin = this.$route.params.hutnummer
        const campangeRoute = this.$route.params.campagne

        const cruiseID = parseInt(pieces.slice(-1)[0])

        //Sanity checks
        const campagne = campangeRoute ? campangeRoute : 0
        const cabinIndex = selectedCabin ? selectedCabin : 0

        let departureDate
        if (this.$route.params.departureDate) {
            let routeDeparture = this.$route.params.departureDate
            departureDate = this.moment(routeDeparture, 'DD-MM-YYYY').format(
                'YYYY-MM-DD'
            )
        }

        if (Number.isInteger(cruiseID)) {
            // Loads cruise and mutates default rate
            this.$store.dispatch('loadCruise', {
                cruiseID: cruiseID,
                departureDate: departureDate,
                cabinIndex,
                setRateCode: campagne,
                route: this.$route,
            })
        } else {
            this.$router.push({ name: 'NotFound' })
        }
    },
}
</script>

<style>
p,
a,
div {
    color: #333;
}

.sendCruise-button {
    width: 125px;
    color: #fff;
    height: 44px;
    border: 0;
    background-color: #f39c12;
    cursor: pointer;
    font-size: 14px;
    margin-left: 2px;
}

.sendCruise-button:hover {
    height: 44px;
}

.sendCruise-email {
    float: left;
    height: 44px;
    padding: 0 20px;
    transition: all 0.4s;
    line-height: 44px;
    border: 1px solid #cccccc;
    font-family: sans-serif;
    font-size: 14px;
    width: 275px;
}

#sendCruiseForm fieldset {
    border: 0;
    padding: 0;
    margin: 0;
}

#sendCruiseSuccess {
    font-size: 16px;
    text-align: center;
}

#sendCruiseFromEmail,
#sendCruiseToEmail,
#sendCruiseToName,
#sendCruiseFromName {
    width: 300px;
}

.quote-item {
    background: transparent;
    margin: 0 auto !important;
    position: absolute;
    width: 100% !important;
}

.quote-item span {
    background-color: #fff;
}

.quote-item span:first-child {
    padding-left: 10px;
}

.quote-item span:last-child {
    padding-right: 10px;
}

.quote-item .quote-stars {
    padding-left: 10px;
}
.boxspacing {
    margin-bottom: 18px !important;
}

#center-map {
    width: 100%;

    float: left;
}
@media screen and (min-width: 1024px) {
    #center-map {
        width: 350px;
    }
}
</style>
